import styled from 'styled-components'

import { theme } from '../../../styles/theme'

export const Container = styled.div`
  padding: 10px;

  @media (min-width: 768px) {
    padding: 0px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
`

export const RoundedImage = styled.img`
  width: 216px;
  height: 216px;
  border-radius: 50%;
  margin: 0 auto;
  display: block;
  margin-bottom: 10px;

  background-color: ${theme.colors.lightGreen};

  object-fit: cover;
`

export const WarningText = styled.div`
  text-align: center;
  margin-bottom: 10px;
  color: ${theme.colors.erro};
  font-size: ${theme.font.sizes.small};
`

export const Button = styled.button`
  background-color: ${theme.colors.green2};

  border: none;
  padding: 10px 20px;
  border-radius: 8px;

  color: ${theme.colors.white};
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};

  cursor: pointer;

  @media (min-width: 768px) {
    padding: 20px 40px;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
`
